// Fetch list

export const FETCH = 'trailerDocuments.FETCH'
export const FETCH_FOR_MAP = 'trailerDocuments.FETCH_FOR_MAP'
export const FETCH_STARTED = 'trailerDocuments.FETCH_STARTED'
export const FETCH_FULFILLED = 'trailerDocuments.FETCH_FULFILLED'
export const FETCH_REJECTED = 'trailerDocuments.FETCH_REJECTED'
export const FETCH_CANCELLED = 'trailerDocuments.FETCH_CANCELLED'

export const SORTING_CHANGED = 'trailerDocuments.SORTING_CHANGED'

// Fetch one

export const FETCH_ONE = 'trailerDocuments.FETCH_ONE'
export const FETCH_ONE_STARTED = 'trailerDocuments.FETCH_ONE_STARTED'
export const FETCH_ONE_FULFILLED = 'trailerDocuments.FETCH_ONE_FULFILLED'
export const FETCH_ONE_REJECTED = 'trailerDocuments.FETCH_ONE_REJECTED'
export const FETCH_ONE_CANCELLED = 'trailerDocuments.FETCH_ONE_CANCELLED'

// Save

export const SAVE = 'trailerDocuments.SAVE'
export const SAVE_STARTED = 'trailerDocuments.SAVE_STARTED'
export const SAVE_FULFILLED = 'trailerDocuments.SAVE_FULFILLED'
export const SAVE_REJECTED = 'trailerDocuments.SAVE_REJECTED'
export const SAVE_CANCELLED = 'trailerDocuments.SAVE_CANCELLED'
export const SAVE_DUPLICITY_FOUND = 'trailerDocuments.SAVE_DUPLICITY_FOUND'

// Delete

export const DELETE = 'trailerDocuments.DELETE'
export const DELETE_STARTED = 'trailerDocuments.DELETE_STARTED'
export const DELETE_FULFILLED = 'trailerDocuments.DELETE_FULFILLED'
export const DELETE_REJECTED = 'trailerDocuments.DELETE_REJECTED'
export const DELETE_CANCELLED = 'trailerDocuments.DELETE_CANCELLED'

// Clear

export const CLEAR = 'trailerDocuments.CLEAR'

// Load files

export const FETCH_FILES = 'trailerDocuments.FETCH_FILES'
export const FETCH_FILES_STARTED = 'trailerDocuments.FETCH_FILES_STARTED'
export const FETCH_FILES_FULFILLED = 'trailerDocuments.FETCH_FILES_FULFILLED'
export const FETCH_FILES_REJECTED = 'trailerDocuments.FETCH_FILES_REJECTED'
export const FETCH_FILES_CANCELLED = 'trailerDocuments.FETCH_FILES_CANCELLED'

// Upload files

export const UPLOAD_FILES = 'trailerDocuments.UPLOAD_FILES'
export const UPLOAD_FILES_STARTED = 'trailerDocuments.UPLOAD_FILES_STARTED'
export const UPLOAD_FILES_FULFILLED = 'trailerDocuments.UPLOAD_FILES_FULFILLED'
export const UPLOAD_FILES_REJECTED = 'trailerDocuments.UPLOAD_FILES_REJECTED'
export const UPLOAD_FILES_CANCELLED = 'trailerDocuments.UPLOAD_FILES_CANCELLED'

// Delete file

export const DELETE_FILE = 'trailerDocuments.DELETE_FILE'
export const DELETE_FILE_STARTED = 'trailerDocuments.DELETE_FILE_STARTED'
export const DELETE_FILE_FULFILLED = 'trailerDocuments.DELETE_FILE_FULFILLED'
export const DELETE_FILE_REJECTED = 'trailerDocuments.DELETE_FILE_REJECTED'
export const DELETE_FILE_CANCELLED = 'trailerDocuments.DELETE_FILE_CANCELLED'


// Export

export const EXPORT = 'trailerDocuments.EXPORT'
export const EXPORT_FULFILLED = 'trailerDocuments.EXPORT_FULFILLED'
